import useSWRWithCache from '../../../../1_shared/api/lib/useSWRWithCache';
import { IOption } from '../../../../1_shared/config/interfaces/IOption';
import { getDictionaries } from '../../../../1_shared/api/dictionary';

// TODO: учесть при рефакторинге передачу url пропсом, а типы дженериком
const useFiltersDictionaries = () => {
  const { data: workWithOptions } = useSWRWithCache<IOption<string>[]>(
    '/spec/work-withs',
    getDictionaries,
  );
  const { data: keyThemesOptions } = useSWRWithCache<IOption<string>[]>(
    '/spec/key-themes',
    getDictionaries,
  );
  const { data: specialitiesOptions } = useSWRWithCache<IOption<string>[]>(
    '/spec/specialities',
    getDictionaries,
  );
  const { data: dictionaryMethods } = useSWRWithCache<IOption[]>(
    '/spec/work-methods',
    getDictionaries,
  );

  return {
    workWithOptions,
    keyThemesOptions,
    specialitiesOptions,
    dictionaryMethods,
  };
};

export { useFiltersDictionaries };
